import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

const NeutralIcon = (props: IconProps) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 72 72"
      {...props}
    >
      <path fill="#FFCC4D" d="M72 36a36 36 0 1 1-72 0 36 36 0 0 1 72 0Z" />
      <path
        fill="#664500"
        d="M23 40c3 0 5-3 5-7s-2-7-5-7-5 3-5 7 2 7 5 7Zm26 0c3 0 5-3 5-7s-2-7-5-7-5 3-5 7 2 7 5 7Zm1 12H22a2 2 0 0 1 0-4h28a2 2 0 0 1 0 4Z"
      />
    </Icon>
  );
};

export default NeutralIcon;
